import Application from "../../Application";
import GetRuleGroupsInteractor from "./GetRuleGroupsInteractor";
import RuleGroupsPresenter, {
  IRuleGroupsPresenter
} from "../../presenter/evaluation/RuleGroupsPresenter";

export default class ShowRuleGroupsInteractor {
  private application: Application;
  private getRuleGroups: GetRuleGroupsInteractor;
  private output?: IRuleGroupsPresenter;

  constructor(application, getRuleGroups) {
    this.application = application;
    this.getRuleGroups = getRuleGroups;
  }

  execute() {
    this.output = RuleGroupsPresenter({
      application: this.application,
      initialState: {
        ruleGroups: []
      }
    });

    this.getRuleGroups.execute().then(this.output.setRuleGroups);

    return this.output;
  }
}
